export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '什么是女仆咖啡厅？',
    answer: '女仆咖啡厅是一种源自日本的主题咖啡厅，服务人员穿着维多利亚风格的女仆装，以"主人/大小姐"称呼顾客，提供饮品、简餐以及互动表演等服务。它不仅是一个消费场所，更通过温柔、体贴的服务为顾客创造一种被珍视的独特体验。女仆咖啡厅的核心价值在于情感连接——在这里，每位顾客都能感受到真诚的关怀与陪伴。',
  },
  {
    question: '女仆不只是工作是什么意思？',
    answer: '"女仆不只是工作"是一个核心理念，强调女仆文化和女仆职业超越了简单的劳动交换。对从业者来说，女仆工作是角色认同、自我成长和社群归属的重要途径；对顾客来说，女仆服务提供的不仅是食物和饮品，更是情感连接、心灵慰藉和一种独特的生活方式体验。这个理念鼓励人们从更深层次理解女仆文化的多元价值。',
  },
  {
    question: '女仆咖啡厅适合什么样的人去？',
    answer: '女仆咖啡厅欢迎所有对女仆文化感兴趣的人。无论你是二次元爱好者、寻找放松空间的上班族、对日本文化感兴趣的好奇者，还是单纯想体验独特服务的人，都能在女仆咖啡厅找到属于自己的体验。许多店铺也欢迎女性顾客和家庭顾客。重要的是保持开放的心态和对服务人员的尊重。',
  },
  {
    question: '去女仆咖啡厅需要注意什么礼仪？',
    answer: '首先，请保持对女仆的基本尊重——不要触碰女仆，不要询问私人联系方式，拍照前务必征得同意。其次，理解这是一个提供情感服务的场所，而非约会服务。第三，遵守店铺的具体规则，如计时收费制度、最低消费要求等。最重要的是，以开放和友善的心态享受这段独特的体验。',
  },
  {
    question: '女仆咖啡厅与普通咖啡厅有什么不同？',
    answer: '最本质的区别在于情感服务的维度。普通咖啡厅是功能性的——你购买饮品，坐下喝完离开。而女仆咖啡厅提供的是一种沉浸式的情感体验：女仆会用"欢迎回家"迎接你，在你面前为饮品"施魔法"，与你聊天互动，甚至进行小型表演。这些看似简单的互动，创造了一种普通咖啡厅无法复制的温暖氛围和情感连接。',
  },
  {
    question: '男生可以去女仆咖啡厅吗？会不会很奇怪？',
    answer: '当然可以！女仆咖啡厅的顾客群体非常多元，男性顾客是重要组成部分。在女仆咖啡厅文化中，男性顾客被称为"主人"，女性顾客被称为"大小姐"。无论性别，每个走进女仆咖啡厅的人都是为了体验那份独特的温暖和关怀。所以完全不需要担心——保持尊重和开放的心态，尽情享受体验就好。',
  },
  {
    question: '女仆的工作真的快乐吗？',
    answer: '和任何工作一样，女仆工作也有快乐和挑战。快乐来自于与客人的温暖互动、同事间的深厚情谊、以及自我成长的成就感。挑战则包括高强度的情感劳动、不规律的工作时间、以及社会对这份职业的某些偏见。但大多数长期从业者都会告诉你——这份工作让他们变得更自信、更善于沟通、更懂得温柔对待他人和自己。这或许就是"女仆不只是工作"的最好证明。',
  },
  {
    question: '如何成为一名女仆？需要什么条件？',
    answer: '不同店铺的要求略有不同，但通常包括：年满18周岁、良好的沟通能力和亲和力、基本的礼仪素养。外貌不是最重要的因素——温暖的笑容和真诚的态度远比精致的外表更能打动客人。许多店铺会提供系统的培训，包括服务流程、互动技巧、简单表演等。如果你对女仆职业感兴趣，可以从关注目标店铺的招聘信息开始。',
  },
];